import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@copro/api';
import { enqueueSnackbar } from '../../../components/GlobalSnackbar/snackbarStore';
import { keys } from './keys';

type Variables = {
  spaceId: string;
};

async function disconnectDrive(variables: Variables): Promise<void> {
  const { error } = await apiClient.functions.invoke('google-drive-disconnect', {
    body: variables,
  });

  if (error) {
    throw error;
  }
}

export default function useDisconnectDrive() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: disconnectDrive,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: keys.config(variables.spaceId) });
      enqueueSnackbar('Google Drive déconnecté.', 'success');
    },
    onError: (err: Error) => {
      enqueueSnackbar(err.message || 'Échec de la déconnexion.', 'error');
    },
  });
}
